import { render } from "./Haccps-add.vue?vue&type=template&id=156ace89"
import script from "./Haccps-add.vue?vue&type=script&lang=js"
export * from "./Haccps-add.vue?vue&type=script&lang=js"

import "./Haccps-add.vue?vue&type=style&index=0&id=156ace89&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__